import React from "react"
import { Box } from "@mui/material"

import { AppBasicTable, AppCardTitle, AppPillToggle, AppResultsSkeleton } from "@components"
import { dateHomeColumn, searchesHomeColumn, sitesHomeColumn, usersHomeColumn } from "./columns"
import { useDateTable } from "Pages/Main/Home/@hooks"
import { dateUserTableData, isDateRangeLoading, userSiteTableData } from "Pages/Main/Home/@signals"


export default function SearchAnalyticsSummaryTable() {
	const { showDateTable, setShowDateTable } = useDateTable()

	if (isDateRangeLoading.value) return <AppResultsSkeleton rows={9} columns={3}/>

	return <AppBasicTable
		data={showDateTable ? dateUserTableData?.value?.bookingDateUser : userSiteTableData.value}
		Components={{
			Title: () => <Box>
				<AppCardTitle icon="table-list" title={`Summary of searches per ${showDateTable ? "Date & User" : "User & Site"}`}/>
				<AppPillToggle
					data-tour-id="tour-summary-view"
					sx={{ mt: 1.5 }}
					value={showDateTable ? 'date' : 'site'}
					options={[
						{ value: 'site', label: 'User & Site' },
						{ value: 'date', label: 'Date & User' },
					]}
					onChange={view => setShowDateTable(view === 'date')}
				/>
			</Box>
		}}
		sx={{ height: 313 }}
		headers={[[
			{ label: showDateTable ? "Date" : "Name" },
			{ label: showDateTable ? "Name" : "Website" },
			{ label: "Searches" },
		]]}
		columns={showDateTable
			? [dateHomeColumn(), usersHomeColumn(), searchesHomeColumn()]
			: [usersHomeColumn(), sitesHomeColumn(), searchesHomeColumn()]}
		setHeaderCellProps={(_, idx) => ({
			sx: {
				width: 1 / 3,
				textAlign: idx !== 2 && "left !important"
			}
		})}
	/>
}